import { Component, Fragment, h, Prop, Element } from '@stencil/core';
import { setAttributesToSlottedElement } from '../../../utils/utils';

@Component({
  tag: 'app-launch-text-button',
  styleUrl: 'text-button.css',
  shadow: true,
})
export class TextButton {
  @Prop() label: string;
  @Prop() isLink?: boolean;
  @Prop() href?: string;
  @Prop() iconDx?: string;
  @Prop() iconSx?: string;
  @Prop() targetBlank?: boolean;

  @Element() hostElement: HTMLElement;

  componentDidLoad() {
    if (this.isLink && this.targetBlank) {
      this.setTargetBlankToSlottedAnchor();
    }
  }

  private setTargetBlankToSlottedAnchor() {
    setAttributesToSlottedElement({
      hostElement: this.hostElement,
      slottedElementTag: 'a',
      attributes: [
        { name: 'target', value: '_blank' },
        { name: 'rel', value: 'noreferrer noopener' },
      ],
    });
  }

  render() {
    return (
      <Fragment>
        {this.isLink ? (
          this.href ? (
            <a href={this.href} id="button" target={this.targetBlank ? '_blank' : '_self'} rel={this.targetBlank ? 'noreferrer noopener' : ''}>
              <span id="label">
                {this.iconSx && <i class="icon" innerHTML={this.iconSx}></i>}
                {this.label}
                {this.iconDx && <i class="icon" innerHTML={this.iconDx}></i>}
              </span>
            </a>
          ) : (
            <div id="button">
              <div id="label">
                {this.iconSx && <i class="icon" innerHTML={this.iconSx}></i>}
                {this.label ? this.label : <slot></slot>}
                {this.iconDx && <i class="icon" innerHTML={this.iconDx}></i>}
              </div>
            </div>
          )
        ) : (
          <button id="button">
            <div id="label">
              {this.iconSx && <i class="icon" innerHTML={this.iconSx}></i>}
              {this.label ? this.label : <slot></slot>}
              {this.iconDx && <i class="icon" innerHTML={this.iconDx}></i>}
            </div>
          </button>
        )}
      </Fragment>
    );
  }
}
